import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[680px] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20composition%20of%20carefully%20curated%20fashion%20and%20lifestyle%20items%20including%20a%20pair%20of%20cream%20leather%20sneakers%20a%20tan%20leather%20handbag%20a%20soft%20cashmere%20scarf%20and%20minimalist%20gold%20jewelry%20all%20arranged%20on%20a%20warm%20textured%20linen%20surface%20with%20soft%20morning%20light%20streaming%20from%20the%20upper%20left%20creating%20elegant%20elongated%20shadows%20European%20editorial%20aesthetic%20warm%20beige%20ivory%20and%20terracotta%20tones%20clean%20refined%20atmosphere&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti moda"
          title="Itaobuy Spreadsheet prodotti moda"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <Navbar />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-16 flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16">
        <div className="flex-1 text-center lg:text-left">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            {t('hero.badge')}
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-[1.08] mb-8">
            {t('hero.title1')}
            <br />
            {t('hero.title2')}
            <br />
            {t('hero.title3')}
          </h1>
        </div>

        <div className="flex-1 flex flex-col justify-end text-center lg:text-left">
          <p className="text-background-50/85 text-base md:text-lg leading-relaxed mb-8 max-w-md mx-auto lg:mx-0">
            {t('hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaPrimary')}
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1 text-background-50 text-sm font-medium border-b border-background-50/40 hover:border-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaSecondary')}
              <i className="ri-arrow-right-line text-xs"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 pb-10">
        <div className="rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20flat%20lay%20of%20diverse%20fashion%20and%20lifestyle%20products%20including%20sneakers%20bags%20accessories%20and%20clothing%20items%20spread%20across%20a%20warm%20cream%20surface%20in%20an%20artistic%20arrangement%20soft%20golden%20morning%20light%20streaming%20from%20the%20left%20creating%20beautiful%20shadows%20European%20editorial%20minimalist%20aesthetic%20warm%20beige%20and%20sand%20tones%20clean%20harmonious%20composition&width=1600&height=500&seq=hero-bottom-v2&orientation=landscape"
            alt="Itaobuy Spreadsheet collezione prodotti"
            title="Itaobuy Spreadsheet collezione prodotti"
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}